import {ACTION_CODE} from './_actionCode';
import {ProjectsService} from '../../services';
import {ErrorModel, ResultModel} from '../../models';
import {LoggerService} from '../../services';

const FUNCTION_CODE = 'UPDATE_PROJECT';

export async function updateProject(token = '', projectId: number | string, payload: Record<string, unknown>) {
    try {
        LoggerService.logInfo('Action - updateProject - Start');

        const result = await ProjectsService.updateProject(token, projectId, payload);

        LoggerService.logInfo('Action - updateProject - End - Success');

        return ResultModel.newSuccessResult(result);
    }
    catch (error) {
        LoggerService.logInfo('Action - updateProject - End - Error');

        const newErr = ErrorModel.newError({
            code: `${ACTION_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue lors de la mise à jour du projet',
            error: error
        });
        LoggerService.logError(error);

        return ResultModel.newErrorResult(newErr);
    }
}
